import React, { useState, useEffect, useRef } from 'react';
import './Registration.css';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import axios from "../../../axiosInstance.js";
import { useParams, useNavigate, useLocation, Link } from 'react-router-dom';
import { Alert, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Modal from '../../../Component/CompanyAdmin/Location1/Modal';
import { Helmet } from 'react-helmet-async';
import { ClipLoader } from 'react-spinners';

import checksuccess from '../../../Assets/checksuccess.png'
import SuccessIcon from '../../../Component/Vendors/FirstAppearComponent/CaseFirstCard/SuccessIcon';
import BottomNavigationBar from '../../../Component/Customers/BottomNavigationBar';
import LocationSearchPanel from '../../../Component/CompanyAdmin/Location1/LocationSearchPanel';
import VehiclePanel from './VehiclePanel';
import ConfirmedRide from './ConfirmedRide';
import LookingForAccptance from './LookingForAcceptance';
import WaitForVehicleCome from './WaitForVehicleCome';
import MapForVendorDistance from '../Map/MapForVendorDistance';
import Loading from '../../../Component/Customers/Cards/Loading';
import AddNewData from '../../../Component/Customers/Cards/AddNewData';
import VehicleImagePanel from './VehicleImagePanel';


import leftArrow from "../../../Assets/navbar/left-arrow.png";

import img1 from '../../../Assets/add/img1.png'
import icon2 from '../../../Assets/add/icon2.svg'
import icon1 from '../../../Assets/add/icon1.svg'
import icon4 from '../../../Assets/add/icon4.svg'
import icon5 from '../../../Assets/add/icon5.svg'
import search from '../../../Assets/add/search.svg'

import icon3 from '../../../Assets/add/icon3.svg'
import rightarrow from '../../../Assets/navbar/right-arrow.svg'
import img2 from '../../../Assets/add/img2.png'
import img3 from '../../../Assets/add/img3.png'
import img4 from '../../../Assets/add/img4.png'
import img5 from '../../../Assets/add/img5.png'
import img6 from '../../../Assets/add/img6.png'
import img7 from '../../../Assets/add/img7.png'
import HomeIcon from '@mui/icons-material/Home';
import Person2Icon from '@mui/icons-material/Person2';
import img1profile from '../../../Assets/profile/img1.png'
// import UploadBlock from './UploadBlocks';
// import SubmitImagesNew from './UploadBlocks';

import AddIcon from '@mui/icons-material/Add';
import MapComponent from '../../../Component/CompanyAdmin/MapComponent/MapComponent';
import TestMap from '../Map/TestMap';
import TestMapLoader from '../Map/TestMapLoader';
import ContactingServiceCard from './ContactingServiceCard';
import logo from '../../../Assets/navbar/logo.svg'
import SelectOnMap from '../../../Component/Customers/Registration/SelectOnMap';
import rightArrow from '../../../Assets/navbar/right-arrow.svg';
import frontLeft from '../../../Assets/crane/front-left.jpg'
import frontRight from '../../../Assets/crane/front-right.jpg'
import rearLeft from '../../../Assets/crane/rear-left.jpg'
import rearRight from '../../../Assets/crane/rear-right.jpg'



import mediumCraneImage from '../../../Assets/crane/mediumCrane.jpg'
import mediumRecoveryVanImage from '../../../Assets/crane/mediumRecoveryVan.jpg'

import mediumFlatbedImage from '../../../Assets/crane/mediumFlatbed.jpg'




import {
    ShieldCheck, UserCheck, FileText, Truck, Box, Calendar, Shield, X, User, Trash
} from "lucide-react";

const steps = [
    { id: "01", title: "Accident Detail" },
    { id: "02", title: "Upload Image" },
    { id: "03", title: "Add Details" },
    { id: "04", title: "Map" },
    { id: "05", title: "Confirm Information" },


];

const config = {
    cUrl: 'https://api.countrystatecity.in/v1/countries/IN',
    ckey: 'NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA=='
};


function AddVehicles({ item, fromPageHere, centerHere, vehicleNo }) {
    const [currentStep, setCurrentStep] = useState("01");
    console.log("currentStep123456", currentStep)
    const [startLoader, setStartLoader] = useState(false);
    const [isModalOpenLooking, setIsModalOpenLooking] = useState(false);
    const [isModalOpenQuantity, setIsModalOpenQuantity] = useState(false);
    const [isLoadingPlaces, setIsLoadingPlaces] = useState(false);



    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
    const navigate = useNavigate();
    const location = useLocation();
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");


    // console.log("itemshere", item)

    const [regNo, setRegNo] = useState('');
    // console.log('reg123', regNo)

    const [vehicleInfo, setVehicleInfo] = useState([]);
    const [comingVehicleInfo, setComingVehicleInfo] = useState([]);
    const [comingVehicle, setComingVehicle] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility
    const [getData, setGetData] = useState({});
    // console.log("GETDATA", getData)
    const [showPopup, setShowPopup] = useState(true);
    const [isVerified, setIsVerified] = useState(false);


    fromPageHere = fromPageHere ? fromPageHere : ""
    // console.log("frompageHere123", fromPageHere)
    const [comingFrom, setComingFrom] = useState('')


    const [showImageDiv, setShowImageDiv] = useState(false)
    const [isMaterialLoaded, setIsMaterialLoaded] = useState(item?.isMaterialLoaded || false)
    console.log('ismargeriald', isMaterialLoaded)

    const [quantity, setQuantity] = useState(item?.quantity || null)
    console.log('quantity', quantity)
    // console.log('quantity123', quantity)
    const [budget, setBudget] = useState(item?.budget || '')

    const [longitude, setLongitude] = useState(item?.longitude || '')
    const [latitude, setLatitude] = useState(item?.latitude || '')

    const [dropLatitude, setDropLatitude] = useState('')
    const [dropLongitude, setDropLongitude] = useState('')

    const [pickupLocation, setPickupLocation] = useState(null)
    const [dropLocation, setDropLocation] = useState(null)
    console.log('pickuploaitn here', pickupLocation, dropLocation)

    // const [location, setLocation] = useState('')
    const [destinationLocation, setDestinationLocation] = useState('')
    const [activeField, setActiveField] = useState(null)

    const [panelOpen, setPanelOpen] = useState(false)
    const [vehiclePanel, setVehiclePanel] = useState(false)
    const [confirmVehicle, setConfirmVehicle] = useState(false)

    const [doneFetching, setDoneFetching] = useState(false)
    // console.log("doneFetching", doneFetching)

    const [selectedCrane, setSelectedCrane] = useState(false);
    const [selectedRecoveryVan, setSelectedRecoveryVan] = useState(false);
    const [selectedBoth, setSelectedBoth] = useState(false);

    const [vehicleFound, setVehicleFound] = useState(false)
    const [vehicleImagesPanel, setVehicleImagesPanel] = useState(false);

    const [vehicleType, setVehicleType] = useState(null)

    const panelRef = useRef(null)
    const vehiclePanelRef = useRef(null)
    const confirmVehicleRef = useRef(null)
    const vehicleFoundRef = useRef(null)
    const vehicleImagesPanelRef = useRef(null)





    useEffect(() => {
        if (getData?.contactPerson) {
            setOnSpotName(getData?.contactPerson)
        }
        if (getData?.CustomerPhone) {
            setOnSpotContact(getData?.CustomerPhone)
        }
    }, [getData])




    // console.log("vheichtype", vehicleType)

    useEffect(() => {
        vehicleType === 'craneandrecoveryvan' ? setIsRecoveryVan(true) : setIsRecoveryVan(false);
        (quantity != "" && Number(quantity) !== 0) ? setIsMaterialLoaded(true) : setIsMaterialLoaded(false);
    }, [vehicleType, quantity])


    useEffect(() => {
        if (vehicleInfo.length !== 0) {
            setComingVehicleInfo([vehicleInfo[0].data]);
        }
    }, [vehicleInfo]);

    useEffect(() => {
        // if (userId.startsWith('CUD-')) getCustomerDriver(userId)
        // else if (userId.startsWith('CC-')) findUserById(userId)
        // getVehicleNumbers()

        if (item !== undefined && item !== null) setIsVerified(true)
        // loadStates(); 
        const storedRegNo = localStorage.getItem('regNo');
        if (storedRegNo) {
            setRegNo(storedRegNo);
        }
        if (localStorage.getItem('isVerified') === 'true') {
            setIsVerified(true)
        }

    }, [token, userId, navigate]);

    // const getCustomerDriver = async (id) => {
    //     const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/findByIdCustomerDriver/${id}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
    //     // console.log("daa", response.data)
    //     if (response.data.message === "data found") {
    //         // setRegNo(response.data.data[0].vehicleNo)
    //         setOnSpotName(response.data.data[0].driverName)
    //         setOnSpotContact(response.data.data[0].driverNumber)
    //     }

    // }





    const findUserById = async (id) => {
        // console.log("HEY", id)
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/findByIdCustomer/${id}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
        // console.log("daa", response.data)
        response.data.data = response.data.data.filter((individualResponse) => {
            if (individualResponse.latitude !== null && individualResponse.longitude !== null) {
                individualResponse.latitude = null;
                individualResponse.longitude = null;
                return true;
            }
            return false;
        })
        // console.log("reginstration data", response.data.data[0]);

        setGetData(response.data.data[0])
    }


    const [selectedVehicleData, setSelectedVehicleData] = useState([]);
    const [selectedFlatbed, setSelectedFlatbed] = useState(false);
    const [selectedNonFlatbed, setSelectedNonFlatbed] = useState(false);
    // console.log('MH0412322', selectedVehicleData)
    const handleChange = (event, selectedVehicle) => {
        // console.log('selectedVehicle123', selectedVehicle)
        setRegNo(event.target.value);
        let option = selectedVehicle.availableOptions.length ? selectedVehicle.availableOptions : [];
        // console.log('optionoptionoptionoptionoption', option)
        setSelectedVehicleData(option)

        // localStorage.setItem('regNo', event.target.value);
    };

    // useEffect(() => {
    //     const storedRegNo = localStorage.getItem('regNo');
    //     if (storedRegNo) {
    //         setRegNo(storedRegNo);
    //     }
    //     if (localStorage.getItem('isVerified') === 'true') {
    //         setIsVerified(true)
    //     }
    // }, []);

    const handleNext = () => {
        // onVehicleData(comingVehicle);
        setIsVerified(true)
        // localStorage.setItem('isVerified', "true");
        closeModal()
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };
    const [images, setImages] = useState({})
    console.log('images123456', images)

    const [photoPreviews, setPhotoPreviews] = useState({
        MajorDamages1: item?.MajorDamages1 || null,
        MajorDamages2: item?.MajorDamages2 || null,
        MajorDamages3: item?.MajorDamages3 || null,
        MajorDamages4: item?.MajorDamages4 || null,
        MajorDamages5: item?.MajorDamages5 || null
    });

    const [photos, setPhotos] = useState({
        MajorDamages1: item?.MajorDamages1 || null,
        MajorDamages2: item?.MajorDamages2 || null,
        MajorDamages3: item?.MajorDamages3 || null,
        MajorDamages4: item?.MajorDamages4 || null,
        MajorDamages5: item?.MajorDamages5 || null
    });
    const [expandedImage, setExpandedImage] = useState(null);

    const photoRefs = {


        MajorDamages1: useRef(null),
        MajorDamages2: useRef(null),
        MajorDamages3: useRef(null),
        MajorDamages4: useRef(null),
        MajorDamages5: useRef(null)
    };
    const handleFileChange = (event, type) => {
        const file = event.target.files[0];
        if (file && file.size > 2097152) {
            console.log("File size should be less than 2 MB!");
            setAlertInfo({ show: true, message: "File size should be less than 2 MB", severity: 'error' });
            if (photoRefs[type].current) {
                photoRefs[type].current.value = "";
            }
        } else if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setPhotos(prev => ({ ...prev, [type]: file }));
                setPhotoPreviews(prev => ({ ...prev, [type]: reader.result }));
            };
            reader.readAsDataURL(file);
        }
    };




    // useEffect(() => {
    //     if (vehicleFound) handleSubmit()
    // }, [vehicleFound])

    // console.log("vehiclePanel123", vehicleType)





    const [onSpotName, setOnSpotName] = useState(item?.onSpotName || getData?.contactPerson || '')
    const [onSpotContact, setOnSpotContact] = useState(item?.onSpotContact || getData?.CustomerPhone || '')



    const [fullAddress, setFullAddress] = useState(item?.fullAddress || "");
    const [pincode, setPincode] = useState(item?.pincode || "");
    const [district, setDistrict] = useState(item?.district || "");
    const [states, setStates] = useState([]); // Correctly define states to hold the list of states
    const [selectedState, setSelectedState] = useState(item?.states || ""); // State to track the selected state
    const [pin, setPin] = useState("");
    const [cities, setCities] = useState([]); // State to hold the list of cities
    const [isLoadingCities, setIsLoadingCities] = useState(true);
    const [isLoadingStates, setIsLoadingStates] = useState(true);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRecoveryVan, setIsRecoveryVan] = useState(item?.isRecoveryVan || false);
    const [successDone, setSuccessDone] = useState(false);
    const [accidentVehicleCode, setAccidentVehicleCode] = useState(null);
    const [trackRepeatedRequests, setTrackRepeatedRequests] = useState(null);

    console.log('trackRepeatedRequests1234', trackRepeatedRequests)
    console.log('accidentVehicleCode1234', accidentVehicleCode)
    const [pickupSuggestions, setPickupSuggestions] = useState([])
    const [destinationSuggestions, setDestinationSuggestions] = useState([])




    const { state } = useLocation();

    useEffect(() => {
        // Log the 'center' from the passed state


        if (state?.center) {
            // console.log("Center in Previous Page:", state.center);
            setDropLatitude(state.center[0])
            setDropLongitude(state.center[1])
            setDropLocation(state.placeName)

            setIsVerified(true)
        }
        if (state?.fromPageHere) {
            // console.log("state Data123", state.fromPageHere)
            setComingFrom(state.fromPageHere)
        }

        if (latitude && longitude && dropLatitude && dropLongitude) {
            const getNearByVendor = async () => {
                try {
                    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/findNearbyLocation/${userId}`, {
                        pickuplatitude: latitude,
                        pickuplongitude: longitude,
                        dropLatitude: dropLatitude,
                        dropLongitude: dropLongitude,
                        selectedVendor: 'crane'
                    }, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    if (response.status === 200) {
                        setAlertInfo({ show: true, message: "get vendor!!!", severity: 'success' });


                    } else {
                        setAlertInfo({ show: true, message: "failed to get Vendor", severity: 'error' });

                    }
                }
                catch (error) {
                    console.error("Error uploading photos:", error);
                    const errorMessage = error.response?.data?.message || 'An error occurred';
                    if (errorMessage === "jwt expired") {
                        setAlertInfo({ show: true, message: "Your session has expired. Redirecting to login...", severity: 'error' });

                        setTimeout(() => {
                            window.location.href = '/';
                        }, 2000);
                    } else {
                        setAlertInfo({ show: true, message: "An error occurred while uploading photos.", severity: 'error' });

                    }
                }
            }
            getNearByVendor()
        }



    }, [state]);

    useEffect(() => {
        // Log the 'center' from the passed state
        // console.log("state Data", state)
        if (centerHere) {
            // console.log("Center in Previous Page here:", centerHere);
            setDropLatitude(centerHere[0])
            setDropLongitude(centerHere[1])

            setIsVerified(true)
        }

    }, [centerHere]);





    // useEffect(() => {
    //     loadStates();
    // }, []); // Assuming 'token' and 'userId' are not needed here or should be replaced

    // const loadStates = () => {
    //     setIsLoadingStates(true);
    //     fetch(`${config.cUrl}/states`, {
    //         headers: { "X-CSCAPI-KEY": config.ckey }
    //     })
    //         .then(response => response.json())
    //         .then(data => {
    //             setStates(data);
    //             setIsLoadingStates(false);
    //         })
    //         .catch(error => {
    //             console.error("Error loading states:", error);
    //             setIsLoadingStates(false);
    //         });
    // };

    // const loadCities = (stateCode) => {
    //     setIsLoadingCities(true);
    //     fetch(`${config.cUrl}/states/${stateCode}/cities`, {
    //         headers: { "X-CSCAPI-KEY": config.ckey }
    //     })
    //         .then(response => response.json())
    //         .then(data => {
    //             setCities(data);
    //             setIsLoadingCities(false);
    //         })
    //         .catch(error => {
    //             console.error("Error loading cities:", error);
    //             setIsLoadingCities(false);
    //         });
    // };

    // // console.log("FORMDATA908", formData)
    const fullAddress1 = `${fullAddress}, ${district},${pin}, ${selectedState}`;
    // console.log("fulladdresss", fullAddress1)
    // const url = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&q=${encodeURIComponent(fullAddress1)}`;
    // console.log("url", url)

    // useEffect(() => {
    //     const getLonLat = async () => {
    //         try {
    //             // console.log("fulladdresskill", fullAddress1)
    //             const response = await axiosInstance.get(url);
    //             // console.log("response latitude", response.data)
    //             const location = response.data[0];
    //             setLatitude(location.lat);
    //             setLongitude(location.lon);
    //             // console.log(`ANMOL Latitudehere: ${location.lat}, Longitudehere: ${location.lon}`)
    //             setLocation(` Latitude: ${location.lat}, Longitude: ${location.lon}`);
    //         } catch (error) {
    //             // setLocation("An error occurred while fetching the coordinates.");
    //         }
    //     }
    //     getLonLat()
    // }, [fullAddress1])

    // useEffect(() => {
    //     const getLocation = () => {
    //         setLatitude('');
    //         setLongitude('');
    //         if (navigator.geolocation) {
    //             navigator.geolocation.getCurrentPosition(showPosition, showError);
    //         } else {
    //             setLocation('Geolocation is not supported by this browser.');
    //         }
    //     };
    //     getLocation()
    // }, [])


    // const showPosition = async (position) => {
    //     // console.log("altiudaf", position.coords)
    //     const { latitude, longitude } = position.coords;
    //     setLatitude(latitude);
    //     setLongitude(longitude);

    //     try {
    //         const response = await fetch(
    //             `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
    //         );
    //         const data = await response.json();
    //         if (data && data.address) {
    //             const { road, city, state, country } = data.address;
    //             setPickupLocation(`${road || ''}, ${city || ''}, ${state || ''}, ${country || ''}`);
    //         } else {
    //             setPickupLocation('Location details not found.');
    //         }
    //     } catch (error) {
    //         setLocation('Error fetching location details.');
    //     }
    // };

    // const showError = (error) => {
    //     switch (error.code) {
    //         case error.PERMISSION_DENIED:
    //             setLocation('User denied the request for Geolocation.');
    //             break;
    //         case error.POSITION_UNAVAILABLE:
    //             setLocation('Location information is unavailable.');
    //             break;
    //         case error.TIMEOUT:
    //             setLocation('The request to get user location timed out.');
    //             break;
    //         case error.UNKNOWN_ERROR:
    //             setLocation('An unknown error occurred.');
    //             break;
    //         default:
    //             setLocation('An error occurred while fetching location.');
    //     }
    // };

    let finalSelectedService = 'crane';
    let [accidentDataObject, setAccidentDataObject] = useState({})

    console.log('accidentDataObject', accidentDataObject)

    const [locationData, setLocationData] = useState({});

    const handleLocationChange = (data) => {
        console.log("Got location data from child:", data);
        setLocationData(data);
    };


    useEffect(() => {


        let fdata = JSON.parse(localStorage.getItem('formData') || '[]')
        // console.log("fdata", fdata)

        let pickupLoc = localStorage.getItem('pickupLoc')
        let lat = parseFloat(localStorage.getItem('pickLatitude'))
        let lon = parseFloat(localStorage.getItem('pickLongitude'))

        let dropLoc = localStorage.getItem('dropLoc')
        let dropLatitude = parseFloat(localStorage.getItem('dropLatitude'))
        let dropLongitude = parseFloat(localStorage.getItem('dropLongitude'))

        let userId = localStorage.getItem('userId')


        // console.log(pickupLoc)
        // console.log(lat)
        // console.log(lon)

        // console.log(dropLoc)
        // console.log(dropLatitude)
        // console.log(dropLongitude)

        // if (fdata.vehicleNo ) {
        console.log('images123123132', images)
        setAccidentDataObject(prev => ({
            ...prev,
            regNo: fdata.vehicleNo,
            fullAddress,
            district,
            pincode,
            onSpotContact: fdata.driverNumber,
            onSpotName: fdata.driverName,
            isRecoveryVan,
            isMaterialLoaded,
            quantity,
            budget,
            ...images,  // spread the filtered images here
            // ...photos,
            // ...comingVehicle,
            // ...getData,
            latitude: lat,
            longitude: lon,
            pickupLocation: pickupLoc,
            dropLocation: dropLoc,
            dropLatitude: dropLatitude,
            dropLongitude: dropLongitude,
            selectedOptions: vehicleType,
            CustomerCode: userId
        }));



        // console.log('accidentDataObject', accidentDataObject)
        // }
    }, [
        regNo,
        fullAddress,
        pincode,
        onSpotContact,
        onSpotName,
        isRecoveryVan,
        isMaterialLoaded,
        quantity,
        budget,
        photos,
        comingVehicle,
        getData,
        images,
        vehicleType,
        latitude,
        dropLatitude,
        longitude,
        dropLongitude
    ]);

    const [minEstimatedAmount, setMinEstimatedAmount] = useState(null)
    const [maxEstimatedAmount, setMaxEstimatedAmount] = useState(null)
    const [minEstimatedDuration, setMinEstimatedDuration] = useState(null)
    const [maxEstimatedDuration, setMaxEstimatedDuration] = useState(null)
    // const [estimatedUrl, setEstimatedUrl] = useState(null)


    const handleSubmit = async (e) => {

        // console.log('handleSubmit calling:');
        // setEstimatedUrl(accidentDataObject.estimateUrl)
        setMinEstimatedAmount(accidentDataObject.minAmount)
        setMaxEstimatedAmount(accidentDataObject.maxAmount)
        setMinEstimatedDuration(accidentDataObject.minDuration)
        setMaxEstimatedDuration(accidentDataObject.maxDuration)

        localStorage.setItem('minDuration', accidentDataObject.minDuration)
        localStorage.setItem('maxDuration', accidentDataObject.maxDuration)
        localStorage.setItem('maxAmount', accidentDataObject.maxAmount.toFixed(2))



        const { vendorData, ...rest } = accidentDataObject;
        localStorage.setItem('accidentDataObject', JSON.stringify(rest));
        console.log('accidentDataObject before submit:', accidentDataObject);
        const formDataObj = new FormData();
        for (const key in accidentDataObject) {
            if (accidentDataObject[key]) {
                if (accidentDataObject[key] instanceof File) {
                    formDataObj.append(key, accidentDataObject[key], accidentDataObject[key].name);
                } else {
                    formDataObj.append(key, accidentDataObject[key]);
                }
            }
        }
        formDataObj.append('trackRepeatedRequests', trackRepeatedRequests);
        formDataObj.append('AccidentVehicleCode', accidentVehicleCode);

        for (let pair of formDataObj.entries()) {
            console.log(pair[0] + ":" + pair[1])
        }

        // setIsModalLast(true)

        // const formDataObj = new FormData();
        // // console.log("accidentDataO123bject", accidentDataObject)
        // for (const key in accidentDataObject) {
        //     if (accidentDataObject[key]) {  // Check if the data is not undefined or null

        //         if (accidentDataObject[key] instanceof File) {
        //             formDataObj.append(key, accidentDataObject[key], accidentDataObject[key].name);
        //         } else {
        //             if (key === 'vendorData' || key == 'images') {
        //                 // console.log('vedorada', accidentDataObject[key])
        //                 continue;
        //             }
        //             formDataObj.append(key, accidentDataObject[key]);
        //         }
        //     }
        // }


        // for (const key in images) {
        //     const file = images[key];
        //     if (file instanceof File) {
        //         formDataObj.append(`images[${key}]`, file, file.name);
        //     }
        // }
        // // formDataObj.append("chooseFromSelectedServiceFinal", accidentDataObject.chooseFromSelectedServiceFinal);
        // formDataObj.append("minAmount", accidentDataObject.minAmount);
        // formDataObj.append("maxAmount", accidentDataObject.maxAmount);
        // formDataObj.append("minDuration", accidentDataObject.minDuration);
        // formDataObj.append("maxDuration", accidentDataObject.maxDuration);
        // formDataObj.append("vendorData", JSON.stringify(accidentDataObject.vendorData));
        // formDataObj.append('trackRepeatedRequests', trackRepeatedRequests)

        // for (let pair of formDataObj.entries()) {
        //     // console.log(`${pair[0]}:`, pair[1]);
        // }


        // console.log('formData:', formDataObj);
        // console.log('accidentDataObject:', accidentDataObject);

        // const formDataObj = {
        //     "regNo": "MH04EI2343",
        //     "onSpotContact": "9223423421",
        //     "onSpotName": "DUMMY CUSTOMER",
        //     "latitude": 19.2473688,
        //     "longitude": 72.9802880,
        //     "pickupLocation": "sector 34",
        //     "dropLocation": "mumbai",
        //     "dropLatitude": 18.9324111,
        //     "dropLongitude": 72.8233330,
        //     "selectedOptions": "recoveryVan",
        //     "CustomerCode": "CC-ea5ff8d5-9058-476a-8df1-97ddc452f010",
        //     "chooseFromSelectedServiceFinal": "mediumRecoveryVan",
        //     "minAmount": 2495.385,
        //     "maxAmount": 2495.385,
        //     "minDuration": "0h 0m",
        //     "maxDuration": "0h 0m",
        //     "vendorData": "[{\"fromVendorLocationToPickDistance\":4.3095,\"fromtPickToDropDistance\":1712.9627,\"fromVendorLocationToPickDuration\":\"5m 28s\",\"fromPickToDropDuration\":\"20h 30m\",\"totalDistance\":1717.2721999999999,\"totalDuration\":\"20h 35m\",\"amount\":732.6988,\"type\":\"mediumRecoveryVan\",\"vendorDriverId\":\"VED-5bc8363e-48fc-40ba-93a1-9e5885e6dcd2\",\"vendorId\":\"VC-e6622993-922d-4ec2-93d6-88380cf2b6fb\"},{\"fromVendorLocationToPickDistance\":8.3601,\"fromPickToDropDistance\":1712.9627,\"fromVendorLocationToPickDuration\":\"10m 45s\",\"fromPickToDropDuration\":\"20h 30m\",\"totalDistance\":1721.3228000000001,\"totalDuration\":\"20h 40m\",\"amount\":951.4312,\"type\":\"mediumRecoveryVan\",\"vendorDriverId\":\"VED-16e7e404-5c3a-4046-b23a-0d136d73bfd0\",\"vendorId\":\"VC-e6622993-922d-4ec2-93d6-88380cf2b6fb\"},{\"fromVendorLocationToPickDistance\":34.6939,\"fromPickToDropDistance\":1712.9627,\"fromVendorLocationToPickDuration\":\"37m 13s\",\"fromPickToDropDuration\":\"20h 30m\",\"totalDistance\":1747.6565999999998,\"totalDuration\":\"21h 7m\",\"amount\":94373.4564,\"type\":\"mediumRecoveryVan\",\"vendorDriverId\":\"VED-8f18b092-b056-43c7-abac-829f60f613d5\",\"vendorId\":\"VC-e65cb7a0-05be-40b0-b254-9278ecb650d5\"},{\"fromVendorLocationToPickDistance\":245.0011,\"fromPickToDropDistance\":1712.9627,\"fromVendorLocationToPickDuration\":\"3h 2m\",\"fromPickToDropDuration\":\"20h 30m\",\"totalDistance\":1957.9638,\"totalDuration\":\"23h 32m\",\"amount\":105730.0452,\"type\":\"mediumRecoveryVan\",\"vendorDriverId\":\"VED-735365d9-d63f-4d84-905a-83d28faa3d46\",\"vendorId\":\"VC-2e0ce68a-e2bf-457f-91e4-bb7d99268262\"},{\"fromVendorLocationToPickDistance\":248.0655,\"fromPickToDropDistance\":1712.9627,\"fromVendorLocationToPickDuration\":\"3h 6m\",\"fromPickToDropDuration\":\"20h 30m\",\"totalDistance\":1961.0282,\"totalDuration\":\"23h 36m\",\"amount\":105895.5228,\"type\":\"mediumRecoveryVan\",\"vendorDriverId\":\"VED-2fde00bd-7e97-4840-a001-1a5080b5c3c8\",\"vendorId\":\"VC-473deef4-2208-42af-8cf7-0aecf4614119\"},{\"fromVendorLocationToPickDistance\":8.3601,\"fromPickToDropDistance\":1712.9627,\"fromVendorLocationToPickDuration\":\"10m 45s\",\"fromPickToDropDuration\":\"20h 30m\",\"totalDistance\":1721.3228000000001,\"totalDuration\":\"20h 40m\",\"amount\":120492.596,\"type\":\"largeRecoveryVan\",\"vendorDriverId\":\"VED-d026ea36-ea65-4257-8e9d-8f73b6b53a43\",\"vendorId\":\"VC-93058755-4305-4689-9f76-2e61dd3af9f0\"},{\"fromVendorLocationToPickDistance\":9.006,\"fromPickToDropDistance\":1712.9627,\"fromVendorLocationToPickDuration\":\"11m 31s\",\"fromPickToDropDuration\":\"20h 30m\",\"totalDistance\":1721.9687,\"totalDuration\":\"20h 41m\",\"amount\":51659.061,\"type\":\"miniRecoveryVan\",\"vendorDriverId\":\"VED-9454b028-dc4c-4aa8-b7da-8e2a62aab41e\",\"vendorId\":\"VC-a25fad20-1b8b-4a0e-b327-897650017015\"}]"

        // }

        // const formDataObj = {
        //     "regNo": accidentDataObject.regNo,
        //     "onSpotContact": accidentDataObject.onSpotContact,
        //     "onSpotName": accidentDataObject.onSpotName,
        //     "latitude": localStorage.getItem('pickLatitude'),
        //     "longitude": localStorage.getItem('pickLongitude'),
        //     "pickupLocation": accidentDataObject.pickupLocation,
        //     "dropLocation": accidentDataObject.dropLocation,
        //     "dropLatitude": localStorage.getItem('dropLatitude'),
        //     "dropLongitude": localStorage.getItem('dropLongitude'),
        //     "selectedOptions": accidentDataObject.selectedOptions,

        //     "CustomerCode": accidentDataObject.CustomerCode,
        //     "chooseFromSelectedServiceFinal": accidentDataObject.chooseFromSelectedServiceFinal,
        //     "minAmount": accidentDataObject.minAmount,
        //     "maxAmount": accidentDataObject.maxAmount,
        //     "minDuration": accidentDataObject.minDuration,
        //     "maxDuration": accidentDataObject.maxDuration,
        //     "vendorData": JSON.stringify(vendorData),
        //     "quantity": accidentDataObject.quantity
        // }

        console.log("accidentDataObject2", formDataObj)

        try {
            setIsLoading(true);
            const response = await axios({
                method: 'POST',
                url: `${process.env.REACT_APP_BACKEND_URL}/addAccidentDetails/${userId}`,
                data: formDataObj,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            console.log("response.data.message", response.data)

            setIsModalWaiting(true)

            if (response.status == 200) {

                // console.log('Last bloack: ======================');

                setSuccessDone(true)
                setConfirmVehicle(false);
                setVehicleFound(true);
                setIsVerified(false)
                setLatitude(null)
                setLongitude(null)
                // setIsModalWaiting(true)
                setAccidentVehicleCode(response.data.AccidentVehicleCode)
                localStorage.setItem('AccidentVehicleCodeForTemp', response.data.AccidentVehicleCode)
                setTrackRepeatedRequests(response.data.trackRepeatedRequests)
                localStorage.setItem("isVerified", 'false')
                localStorage.setItem('regNo', '');
                localStorage.setItem('currentStep', '05')
                setCurrentStep("05")
                setAlertInfo({ show: true, message: "Data Successfully Added!!!", severity: 'success' });
                // navigate('/user-landing-page', { replace: true, state: null })
                // navigate('/crane-dashboard/quotationupdate')

                // return;
            }

        } catch (error) {
            setIsLoading(false);
            console.log("Hey i am the errror", error.response?.data?.message)
            const errorMessage = error.response?.data?.message || 'An error occurred';
            if (errorMessage === "jwt expired") {
                setAlertInfo({ show: true, message: "Your session has expired. Redirecting to login...", severity: 'error' });
                setTimeout(() => {
                    window.location.href = '/';
                }, 2000);
            } else {
                setAlertInfo({ show: true, message: errorMessage, severity: 'error' });
            }
        } finally {
            setIsLoading(false);
        }
    };


    useGSAP(function () {
        if (panelOpen) {
            gsap.to(panelRef.current, {
                height: '100%',
                opacity: 1,
                duration: 1,
                ease: 'power-3.inOut'
            })
        }
        if (!panelOpen) {
            gsap.to(panelRef.current, {
                height: '0%',
                opacity: 0,
                // duration: 1,
                // ease: 'power-3.inOut'
            })
        }
    }, [panelOpen])

    useGSAP(function () {
        if (vehiclePanel) {
            gsap.to(vehiclePanelRef.current, {
                transform: 'translateY(0%)',
                opacity: 1,
                duration: 1,
                ease: 'power-3.inOut',
                zIndex: '1001',
                boxShadow: 'inset -1px -6px 20px 0px #020202',
                height: '300px',
                overflowY: 'auto'
            });
        } else {
            gsap.to(vehiclePanelRef.current, {
                transform: 'translateY(100%)',
                opacity: 0,
                duration: 0,
                zIndex: '1001',
            });
        }
    }, [vehiclePanel]);

    useGSAP(function () {
        if (vehicleImagesPanel) {
            gsap.to(vehicleImagesPanelRef.current, {
                transform: 'translateY(0%)',
                opacity: 1,
                duration: 1,
                ease: 'power-3.inOut',
                zIndex: '1001',
                boxShadow: 'inset -1px -6px 20px 0px #020202',
                height: '400px',
                overflowY: 'auto'

            });
        } else {
            gsap.to(vehicleImagesPanelRef.current, {
                transform: 'translateY(100%)',
                opacity: 0,
                duration: 0,
                zIndex: '1000',
                height: '0px'
            });
        }
    }, [vehicleImagesPanel]);

    useGSAP(function () {
        if (confirmVehicle) {
            gsap.to(confirmVehicleRef.current, {
                transform: 'translateY(0%)',
                opacity: 1,
                duration: 1,
                ease: 'power-3.inOut',
                zIndex: '1001', // Higher zIndex to appear above vehiclePanel
                boxShadow: 'inset -1px -6px 20px 0px #020202',
                height: '95vh',
                overflowY: 'auto'
            });
        } else {
            gsap.to(confirmVehicleRef.current, {
                transform: 'translateY(100%)',
                opacity: 0, // Adjusted to 0 to hide it properly
                duration: 1,
                ease: 'power-3.inOut',
                width: '100%',
                zIndex: '1000', // Lower zIndex when closed
            });
        }
    }, [confirmVehicle]);


    useGSAP(async function () {
        // console.log('helywerewrwer', successDone)
        // await handleSubmit()

        if (vehicleFound) {
            gsap.to(vehicleFoundRef.current, {
                transform: 'translateY(0%)',
                opacity: 1,
                duration: 1,
                ease: 'power-3.inOut',
                width: '100%',
                height: "95vh",
                zIndex: '1001',
                overflowY: 'auto'


            })
        }
        else {
            gsap.to(vehicleFoundRef.current, {
                transform: 'translateY(100%)',
                opacity: 1,
                duration: 1,
                ease: 'power-3.inOut',
                padding: '0px',
                height: "0vh",
                zIndex: '1001',
                padding: '20px'

            })
        }
    }, [vehicleFound])





    const [nowReadOnly, setNowReadOnly] = useState(true)
    useEffect(() => {
        if (fromPageHere !== "allvehicles") setNowReadOnly(false)
    }, [fromPageHere])




    const [miniCrane, setMiniCrane] = useState(null)
    const [mediumCrane, setMediumCrane] = useState(null)
    const [largeCrane, setLargeCrane] = useState(null)
    const [miniRecoveryVan, setMiniRecoveryVan] = useState(null)
    const [mediumRecoveryVan, setMediumRecoveryVan] = useState(null)
    const [largeRecoveryVan, setLargeRecoveryVan] = useState(null)
    const [distance, setDistance] = useState(null)
    const [getDistance, setGetDistance] = useState(false)



    // const getVendorDistanceAndTime = async (e) => {
    //     setGetDistance(true)
    //     const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL}/api/findDistance`, {
    //         data: { pickuplatitude: latitude, pickuplongitude: longitude, dropLatitude: dropLatitude, dropLongitude: dropLongitude, selectedVendor: vehicleType.split(',') },
    //         headers: {
    //             Authorization: `Bearer ${token}`
    //         }
    //     })
    //     setMiniCrane(response.data?.miniCrane);
    //     setMediumCrane(response.data?.mediumCrane);
    //     setLargeCrane(response.data?.largeCrane);
    //     setMiniRecoveryVan(response.data?.miniRecoveryVan);
    //     setMediumRecoveryVan(response.data?.mediumRecoveryVan);
    //     setLargeRecoveryVan(response.data?.largeRecoveryVan);
    //     setDistance(response.data?.distance);


    // }
    function findTrip() {
        setPanelOpen(false)
        setVehiclePanel(true)
    }

    const navigateTo = () => {
        // console.log("userId123", userId)
        // userId.startsWith('CUD-') ? navigate('/all-accident-vehicles') : navigate('/add-new-vehicle-driver')
    }

    const stepRef = useRef(null);

    const stepToPath = {
        "01": "select-location",
        "02": "add-images",
        "03": "choose-vehicle",
        "04": "review-submit",
        "05": "confirmation",
    };

    const pathToStep = {
        "select-location": "01",
        "add-images": "02",
        "choose-vehicle": "03",
        "review-submit": "04",
        "confirmation": "05",
    };

    // useEffect(() => {
    //     const subPath = location.pathname.split('/')[2];
    //     if (subPath && pathToStep[subPath]) {
    //         setCurrentStep(pathToStep[subPath]);
    //     } else {
    //         setCurrentStep("01");
    //         navigate("/addVehicles/select-location", { replace: true });
    //     }
    // }, [location.pathname]);

    useEffect(() => {
        if (locationData) {
            // if (locationData.currentStep) {
            // console.log('step5044345',locationData)
            //     setCurrentStep(locationData.currentStep);
            // }
            //  const step = localStorage.getItem('currentStep') || "01";
            // console.log('step5044',step)
            // setCurrentStep(step);

            console.log('locationData.latitude', locationData.latitude)
            console.log('locationData.longitude', locationData.longitude)
            console.log('locationData.dropLatitude', locationData.dropLatitude  )
            console.log('locationData.dropLongitude', locationData.dropLongitude)

            setLatitude(locationData.latitude || '');
            setLongitude(locationData.longitude || '');
            setPickupLocation(locationData.pickupLocation || '');
            setDropLocation(locationData.dropLocation || '');
            setDropLatitude(locationData.dropLatitude || '');
            setDropLongitude(locationData.dropLongitude || '');
        } else {
            // Fallback to localStorage if needed
            const step = localStorage.getItem('currentStep') || "01";
            console.log('step5044', step)
            setCurrentStep(step);

            if (step === "05") {
                setSuccessDone(true);
                const accidentDataObject = JSON.parse(localStorage.getItem('accidentDataObject') || '{}');
                setMinEstimatedAmount(accidentDataObject?.minAmount);
                setMaxEstimatedAmount(accidentDataObject?.maxAmount);
                setMinEstimatedDuration(accidentDataObject?.minDuration);
                setMaxEstimatedDuration(accidentDataObject?.maxDuration);
            }
        }
    }, [locationData]);

    // useEffect(() => {
    //     const expectedPath = stepToPath[currentStep];
    //     const currentPath = location.pathname.split('/')[2];

    //     if (expectedPath && expectedPath !== currentPath) {
    //         navigate(`/addVehicles/${expectedPath}`, { replace: true });
    //     }
    // }, [currentStep]);

    // useEffect(() => {
    //     const pathSegment = location.pathname.split('/')[2]; // e.g. 'choose-vehicle'
    //     if (pathToStep[pathSegment]) {
    //         setCurrentStep(pathToStep[pathSegment]);
    //     } else {
    //         setCurrentStep("01"); // fallback to default
    //     }
    // }, [location.pathname]);

    //   useEffect(() => {
    //   const expectedPath = stepToPath[currentStep];
    //   const currentPath = location.pathname.split('/')[2];

    //   if (expectedPath && expectedPath !== currentPath) {
    //     navigate(`/addVehicles/${expectedPath}`, { replace: true });
    //   }
    // }, [currentStep, navigate, location.pathname]);

    useEffect(() => {
        console.log("Current Step Changed:", currentStep);
        const newPath = stepToPath[currentStep];
        console.log("Navigating to Path:", newPath);
        if (newPath) {
            navigate(`/addVehicles/${newPath}`, { replace: true });
        }
    }, [currentStep]);

    // this ensures URL and currentStep always sync
    useEffect(() => {
        console.log('location.pathname', location.pathname)
        const pathParts = location.pathname?.split("/"); // e.g., ["", "addVehicles", "add-images"]
        console.log('pathParts', pathParts)
        const subPath = pathParts?.[2];
        console.log('subPath', subPath)

        if (!subPath) {
            navigate("/addVehicles/select-location", { replace: true });
            return;
        }
        console.log('pathToStep[subPath] ', pathToStep[subPath])
        const step = pathToStep[subPath] || "01";
        console.log('step', step)
        setCurrentStep(step); // this updates UI step
        const path = stepToPath[step];
        console.log('path', path)
        navigate(`/addVehicles/${path}`);
    }, [location.pathname]);


    const prevStep = (step) => {
        const path = stepToPath[step];
        if (step === currentStep || !path) return;
        if (path) {
            navigate(`/addVehicles/${path}`);
        }
    };


    const gotToCraneDashboardQuotationUpdate = () => {
        navigateTo('/crane-dashboard/quotationupdate')
    }

    // const [imageKeys, setImageKeys] = useState([
    //     "Front Full",
    //     "Front left",
    //     "Front right",
    //     "Rear Full",
    //     "Rear left",
    //     "Rear right",
    //     "Left side",
    //     "Right side",
    //     "Top side",
    //     "Down side",


    //     ...Array.from({ length: 0 }, (_, i) => `image${i + 1}`),
    // ])

    const MAX_SIZE_MB = 1;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;


    const handleImageChange = async (key, file) => {
        if (!file) return;

        try {
            // Compress image
            setStartLoader(true);
            const compressedFile = await compressImage(file);

            // Size check
            if (compressedFile.size > MAX_SIZE_BYTES) {
                alert('Image should be less than 1 MB.');
                return;
            }

            // Prepare FormData with image + other fields
            const storedVehicleDetails = localStorage.getItem('formData');
            const { vehicleNo, driverName, driverNumber } = JSON.parse(storedVehicleDetails);
            const formData = new FormData();
            formData.append(key, compressedFile); // ✅ important: append actual file
            formData.append('pickupLocation', localStorage.getItem("pickupLoc") || '');
            formData.append('dropLocation', localStorage.getItem("dropLoc") || '');
            formData.append('latitude', localStorage.getItem("pickLatitude") || '');
            formData.append('longitude', localStorage.getItem("pickLongitude") || '');
            formData.append('dropLatitude', localStorage.getItem("dropLatitude") || '');
            formData.append('dropLongitude', localStorage.getItem("dropLongitude") || '');
            formData.append('regNo', vehicleNo || '');
            formData.append('onSpotContact', driverNumber || '');
            formData.append('onSpotName', driverName || '');
            formData.append(
                'AccidentVehicleCode',
                accidentVehicleCode == null ? '' : accidentVehicleCode
            );

            // Save Base64 version locally (for persistence in UI)
            const reader = new FileReader();
            reader.onloadend = async () => {
                const base64 = reader.result;
                const storedImages = JSON.parse(localStorage.getItem("storedImages") || "{}");
                storedImages[key] = base64;
                localStorage.setItem("storedImages", JSON.stringify(storedImages));

                // Send to backend
                console.log(`${process.env.REACT_APP_BACKEND_URL}/api/saveInitialAccidentData/${userId}`)
                for (let pair of formData.entries()) {
                    console.log(`${pair[0]}:`, pair[1]);
                }
                try {
                    const res = await axios.put(
                        `${process.env.REACT_APP_BACKEND_URL}/api/saveInitialAccidentData/${userId}`,
                        formData,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    );


                    if (res.status === 200) {
                        setStartLoader(false)
                        console.log('responsed98237498234', res)
                        setImages((prev) => ({ ...prev, [key]: res.data[key] }));
                        setAccidentVehicleCode(res.data.AccidentVehicleCode)

                    }
                } catch (uploadError) {
                    setStartLoader(false)
                    console.error("Image upload error:", uploadError);
                    alert("Failed to upload image.");
                }
            };
            reader.readAsDataURL(compressedFile);

        } catch (error) {
            console.error("Image processing error:", error);
            alert("Failed to process image.");
        }
    };


    useEffect(() => {
        const loadStoredImages = async () => {
            const storedImages = JSON.parse(localStorage.getItem("storedImages") || "{}");
            const restoredImages = {};
          
            for (const key of Object.keys(storedImages)) {
                const base64 = storedImages[key];

                // Axios call to get blob data
                const res = await axios.get(base64, { responseType: "blob" });

                const blob = res.data; // axios returns the blob directly
                const file = new File([blob], `${key}.jpg`, { type: blob.type });

                restoredImages[key] = file;
            }

            setImages(restoredImages);
        };

        const storedVehicleType = localStorage.getItem('vehicleType');
        const storedService = localStorage.getItem('currentService');
        const storedFlatbedOption = localStorage.getItem('flatbedOption');

        setVehicleType(storedVehicleType);

        if (storedVehicleType === 'crane') {
            setSelectedCrane(true);
            setSelectedRecoveryVan(false);
            setSelectedNonFlatbed(false);
            setSelectedFlatbed(false);
            setSelectedBoth(false);
        } else if (storedVehicleType === 'recoveryVan') {
            setSelectedCrane(false);
            setSelectedRecoveryVan(true); // Optional if you track both/non separately
            setSelectedBoth(false);

            if (storedFlatbedOption === 'Flat-bed') {
                setSelectedFlatbed(true);
                setSelectedNonFlatbed(false);
                setFlatOption('Flat-bed');
            } else if (storedFlatbedOption === 'Non-flat-bed') {
                setSelectedNonFlatbed(true);
                setSelectedFlatbed(false);
                setFlatOption('Non-flat-bed');
            }
        }

        loadStoredImages();
    }, []);


    const compressImage = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    const scale = Math.min(800 / img.width, 800 / img.height, 1); // scale down if larger than 800px
                    canvas.width = img.width * scale;
                    canvas.height = img.height * scale;

                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    console.log('blob23456', ctx)

                    canvas.toBlob(
                        (blob) => {
                            console.log('blob2345', blob)
                            if (blob) {
                                const compressedFile = new File([blob], file.name, { type: file.type });
                                resolve(compressedFile);
                            } else {
                                reject(new Error("Compression failed"));
                            }
                        },
                        file.type,
                        0.7 // quality: 0.0 to 1.0
                    );
                };
                img.onerror = reject;
                img.src = event.target.result;
            };

            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };



    const handleAddImageField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeys((prev) => [...prev, newKey]);
    };

    const moveThrdStage = () => {
        setIsSubmitting(false)
        setIsModalOpenQuantity(false)
        setCurrentStep('03')
        stepRef.current?.scrollIntoView({ behavior: "smooth" });
    }

    const callIsSetIsModalOpenQuantity = () => {
        setIsModalOpenQuantity(false)
        moveThrdStage()
    }

    const setLoaderStage = (e) => {
        setCurrentStep(e)
    }


    const [isModalLast, setIsModalLast] = useState(false);
    const [isModalWaiting, setIsModalWaiting] = useState(false);
    const [chooseFromSelectedServiceFinal, setChooseFromSelectedServiceFinal] = useState(null)
    const [unloadWeight, setUnloadWeight] = useState(3)

    const [vendorData, setVendorData] = useState([]);
    console.log('vnodrdata', vendorData)
    const [incomingAccidentCode, setIncomingAccidentCode] = useState(null)
    const [stats, setStats] = useState({});
    console.log('stats123', stats)

    const getVendorsWithLocation = async (optionalTrackRepeatedRequest = null) => {
        setIsLoading(true);
        setGetDistance(true);
        // optionalAccidentCode != null ? setIncomingAccidentCode(optionalAccidentCode):setIncomingAccidentCode(null);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/findNearByVendorsToShow/${userId}`,
                {
                    pickuplatitude: accidentDataObject.latitude,
                    pickuplongitude: accidentDataObject.longitude,
                    dropLatitude: accidentDataObject.dropLatitude,
                    dropLongitude: accidentDataObject.dropLongitude,
                    selectedVendor: ['crane'], // ['recoveryVan', 'crane']    
                    quantity: accidentDataObject.quantity,
                    vehicleNo: accidentDataObject.regNo,
                    pickupLocation: pickupLocation,
                    dropLocation: dropLocation,
                    trackRepeatedRequests: optionalTrackRepeatedRequest
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const vendorDataArr = response.data?.data || [];
            const summary = response.data?.summary || {};
            console.log('summar12312', summary)
            setVendorData(vendorDataArr);

            // Extract stats dynamically
            const updatedStats = { ...stats };
            const allTypes = [
                'miniRecoveryVan', 'mediumRecoveryVan', 'largeRecoveryVan',
                'miniCrane', 'mediumCrane', 'largeCrane',
            ];

            allTypes.forEach((type) => {
                if (summary[type]) {
                    updatedStats[type] = {
                        minDuration: summary[type]?.minDuration || '',
                        maxDuration: summary[type]?.maxDuration || '',
                        minAmount: summary[type]?.minAmount || 0,
                        maxAmount: summary[type]?.maxAmount || 0,
                        // estimateUrl: summary[type]?.estimateUrl || '',
                        vendorDriverIds: summary[type]?.vendorDriverId || [],
                    };
                } else {
                    updatedStats[type] = {
                        minDuration: '',
                        maxDuration: '',
                        minAmount: 0,
                        maxAmount: 0,
                        vendorDriverIds: [],
                    };
                }
            });

            console.log('vendordriverid123', updatedStats)
            setStats(updatedStats);
            setIsLoading(false);

        } catch (err) {
            console.error("Error fetching vendor data:", err);
        } finally {
            setIsLoading(false);
        }
    };

    // const setNextPage = (e) => {

    //     setCurrentStep(e)
    // }

    // useEffect(() => {
    //     // return

    //     let step = localStorage.getItem('currentStep')
    //     // console.log(step)
    //     setCurrentStep(step);


    //     if (step && step !== '') {
    //         setCurrentStep(step);

    //         // getVendorsWithLocation()
    //         // setCurrentStep('04');

    //         // let pickupLoc = localStorage.getItem('pickupLoc')
    //         // alert(pickupLoc)
    //         // let dropLoc = localStorage.getItem('dropLoc')
    //         // console.log(dropLoc)
    //         // setPickupLocation(pickupLoc)
    //         // setDropLocation(dropLoc)



    //         if (step === '05') {
    //             // return

    //             setSuccessDone(true)
    //             let accidentDataObject = JSON.parse(localStorage.getItem('accidentDataObject' || '{}'))
    //             setMinEstimatedAmount(accidentDataObject?.minAmount)
    //             setMaxEstimatedAmount(accidentDataObject?.maxAmount)
    //             setMinEstimatedDuration(accidentDataObject?.minDuration)
    //             setMaxEstimatedDuration(accidentDataObject?.maxDuration)
    //         }
    //     }

    // }, [])

    const [isModalFlatBed, setIsModalFlatBed] = useState(false);
    const [isModalQuantityFlatBed, setIsModalQuantityFlatBed] = useState(false);
    const [flatOption, setFlatOption] = useState(null);

    const getVendorsWithLocationForFlatBed = async (optionalTrackRepeatedRequest = null) => {
        console.log('accidentDataObject1234', accidentDataObject)
        console.log('accidentDataObject1234', accidentDataObject.reg)

        console.log('optionalTrackRepeatedRequest', optionalTrackRepeatedRequest)
        setIsLoading(true);
        setGetDistance(true);

        // optionalAccidentCode != null ? setIncomingAccidentCode(optionalAccidentCode):setIncomingAccidentCode(null);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/findNearByVendorsToShow/${userId}`,
                {
                    pickuplatitude: accidentDataObject.latitude,
                    pickuplongitude: accidentDataObject.longitude,
                    dropLatitude: accidentDataObject.dropLatitude,
                    dropLongitude: accidentDataObject.dropLongitude,
                    selectedVendor: ['recoveryVan'], // ['recoveryVan', 'crane']
                    chooseFromSelectedSubServiceFinal: localStorage.getItem('flatbedOption'),
                    vehicleNo: accidentDataObject.regNo,
                    pickupLocation: pickupLocation,
                    dropLocation: dropLocation,
                    trackRepeatedRequests: optionalTrackRepeatedRequest
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log('response.data?.data getVendorsWithLocationForFlatBed', response.data?.data)

            const vendorDataArr = response.data?.data || [];
            const summary = response.data?.summary || {};
            console.log('summar12312', summary)
            setVendorData(vendorDataArr);

            // Extract stats dynamically
            const updatedStats = { ...stats };
            const allTypes = [
                'miniRecoveryVan', 'mediumRecoveryVan', 'largeRecoveryVan',
                'miniCrane', 'mediumCrane', 'largeCrane',
            ];

            allTypes.forEach((type) => {
                if (summary[type]) {
                    updatedStats[type] = {
                        minDuration: summary[type]?.minDuration || '',
                        maxDuration: summary[type]?.maxDuration || '',
                        minAmount: summary[type]?.minAmount || 0,
                        maxAmount: summary[type]?.maxAmount || 0,
                        nonGSTCharge: summary[type]?.nonGSTCharge || 0,
                        // estimateUrl: summary[type]?.estimateUrl || '',
                        vendorDriverIds: summary[type]?.vendorDriverId || [],
                    };
                } else {
                    updatedStats[type] = {
                        minDuration: '',
                        maxDuration: '',
                        minAmount: 0,
                        maxAmount: 0,
                        nonGSTCharge: 0,
                        // estimateUrl: '',
                        vendorDriverIds: [],
                    };
                }
            });

            setStats(updatedStats);
        } catch (err) {
            console.error("Error fetching vendor data:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const [imageKeys, setImageKeys] = useState([
        "Front Right",
        "Front Left",
        "Rear Right",
        "Rear Left",
        "Additional Image 1",
        "Additional Image 2",
        "Additional Image 3",
        "Additional Image 4",
        "Additional Image 5",
        "Additional Image 6",

        ...Array.from({ length: 0 }, (_, i) => `image${i + 1}`),
    ])

    // Define your placeholder map (outside the component or at the top)
    const placeholderImages = {
        "Front Right": frontLeft,
        "Front Left": frontRight,
        "Rear Right": rearRight,
        "Rear Left": rearLeft,
    };


    const requiredImageKeys = ["Front Right",
        "Front Left",
        "Rear Right",
        "Rear Left",
    ];

    const isContinueEnabled = requiredImageKeys.every((key) => !!images[key]);


    return (
        <>
            <div>
                {startLoader && (
                    <div className="fixed inset-0 z-[9999] bg-white bg-opacity-80 flex items-center justify-center">
                        <div className="loader2 h-[50px] w-[20px]"></div>
                    </div>
                )}
                <div ref={stepRef} className="bg-white pt-0 px-0 md:pt-[50px] md:px-[80px]  px-[20px] min-h-screen "  >


                    {/* <div style={{ zIndex: "1001" }} className='fixed p-[1rem] top-0 flex items-center justify-between w-screen mb-1'>
                    <img className='w-[3rem]' src={logo} alt="" />

                </div> */}
                <div className={`fixed top-0 left-0 w-full flex items-center justify-between px-3 py-1 z-50 ${currentStep !== '01' ? `bg-white shadow-md` : ''}`}>
                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/logo-navbar-compressed.png' alt="logo" className="h-[3rem] w-[3rem] object-contain" />
                    <Link to='/user-profile-details' className=' h-10 w-10 bg-white flex items-center justify-center rounded-full border shadow'>
                        <User className="text-gray-500" />
                    </Link>
                </div>
                {currentStep != "01" && (
                    <div className="hidden bg-white md:flex pt-[5rem] items-center flex-wrap justify-center gap-[10px] relative pb-[33px]">
                        {steps.map((step, index) => (
                            <div key={index} className="flex items-center relative">
                                <div className="flex flex-col justify-center items-center relative">
                                    {index !== 0 && (
                                        <div
                                            className={`absolute w-full h-1 top-4 ${currentStep > index ? "bg-blue-500" : "bg-gray-300"}`}
                                            style={{ left: "-50%", zIndex: -1 }}
                                        />
                                    )}

                                        <div
                                            className={`w-[32px] text-[#242E39] cursor-pointer bg-[#FFFFFF] h-[32px] border-[2px] flex items-center justify-center rounded-full font-bold`}
                                            style={{
                                                border: currentStep >= step.id ? '3px solid #21A6E9' : '3px solid white',
                                                boxShadow: currentStep >= step.id ? '-3px 0px 20px' : '-3px 0px 20px',
                                                borderColor: currentStep >= step?.id ? '#21A6E9' : '#A1AEBE'
                                            }}
                                            onClick={() => setCurrentStep(step?.id)}
                                        >
                                            {step?.id}
                                        </div>

                                        <p className={`mt-[10px] mb-0 md:text-[13px] text-[10px] text-center font-satoshi font-[500] ${currentStep >= step?.id ? "text-[#21A6E9]" : "text-[#A1AEBE]"
                                            }`}>
                                            {step.title}
                                        </p>
                                    </div>

                                    {index !== steps.length - 1 && (
                                        <div
                                            className={`h-[3px] w-[80px] mx-2 mb-[32px] md:block hidden ${currentStep > steps[index]?.id ? "bg-[#21A6E9]" : "bg-[#A1AEBE]"
                                                }`}
                                        ></div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}


                    {currentStep === "01" && (
                        <div>
                            <SelectOnMap onLocationChange={handleLocationChange} />
                        </div>
                    )}

                    {currentStep === "02" &&
                        <div>
                            <div className="mb-[3rem] bg-[linear-gradient(175deg,_#ffffff,_transparent)] md:bg-[#ffffff] md:w-full rounded-[30px] md:p-[78px] max-w-[1148px] mx-auto p-[20px] pt-[12%] bg-successs">

                                <div className='font-satoshi' >

                                    <div className="flex flex-col items-start my-6">
                                        <div className="flex items-start gap-3 md:-mt-[70px]">
                                            <img
                                                src="https://cdn.pixabay.com/photo/2016/01/03/00/43/upload-1118929_640.png"
                                                className="w-10 h-10 self-center"
                                                alt="Upload Icon"
                                            />
                                            <div className="flex flex-col justify-center mt-[10]" style={{ marginTop: "5px" }}>
                                                <h2 className="text-[1rem] font-semibold">UPLOAD VEHICLE IMAGES</h2>
                                                <p className="text-xs text-gray-500">Upload required vehicle images to proceed with.</p>
                                            </div>
                                        </div>
                                    </div>





                                    <div className="overflow-auto grid grid-cols-2 lg:grid-cols-5 gap-[0.7rem]" style={{ marginTop: "-10px" }}>
                                        {imageKeys.map((key, index) => {
                                            const showPlaceholder = index < 4;

                                            const isUploaded = Boolean(images[key]);

                                            const imageSrc = isUploaded
                                                ? (images[key] instanceof File
                                                    ? URL.createObjectURL(images[key])  // Local file preview
                                                    : images[key]                       // Already an uploaded URL
                                                )
                                                : showPlaceholder
                                                    ? placeholderImages[key]
                                                    : null;

                                            return (
                                                <div
                                                    key={key}
                                                    className="relative rounded-xl border-2 border-dotted border-gray-400"
                                                    style={{ height: "180px" }}
                                                >
                                                    {/* Asterisk at top-right when required and empty */}
                                                    {!isUploaded && index < 4 && (
                                                        // <span className="absolute top-1 right-1 text-red-600 text-lg font-bold z-30">*</span>

                                                        // <span className="absolute top-1 right-1 text-red-600 text-xl font-extrabold z-30 drop-shadow-sm">*</span>

                                                        <span className="absolute top-1 right-1 text-red-700 text-2xl font-black z-30 drop-shadow-md">*</span>


                                                    )}

                                                    <div className="relative w-full h-full rounded-xl overflow-hidden">
                                                        {imageSrc && (
                                                            <img
                                                                src={imageSrc}
                                                                alt={key}
                                                                className={`w-full h-full object-contain ${!isUploaded ? "blur-smm opacity-50" : ""
                                                                    }`}
                                                            />
                                                        )}

                                                        {isUploaded && (
                                                            <button
                                                                type="button"

                                                                onClick={() => {
                                                                    setImages((prev) => {
                                                                        const newImages = { ...prev };
                                                                        delete newImages[key];

                                                                        const storedImages = JSON.parse(localStorage.getItem("storedImages") || "{}");
                                                                        delete storedImages[key];
                                                                        localStorage.setItem("storedImages", JSON.stringify(storedImages));

                                                                        setAccidentDataObject(prevAccidentData => {
                                                                            const updatedAccidentData = { ...prevAccidentData };
                                                                            delete updatedAccidentData[key];
                                                                            return updatedAccidentData;
                                                                        });

                                                                        return newImages;
                                                                    });
                                                                }}
                                                                className="absolute top-1 right-1 bg-red-300 text-white rounded-full w-8 h-8 flex items-center justify-center text-xs hover:bg-red-700 z-20"
                                                                title="Remove Image"
                                                            >
                                                                <Trash />
                                                            </button>
                                                        )}

                                                        {/* Add Button (Only if no uploaded image) */}
                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                document.getElementById(`hiddenFileInput-${key}`).click()
                                                            }
                                                            className={`absolute inset-0 flex items-center justify-center z-10 ${isUploaded ? "pointer-events-none" : ""
                                                                }`}
                                                        >
                                                            {!isUploaded && (
                                                                <div className="bg-gray-700 p-2 rounded-full text-white shadow-lg hover:bg-black">
                                                                    <AddIcon />
                                                                </div>
                                                            )}
                                                        </button>



                                                        <input
                                                            type="file"
                                                            id={`hiddenFileInput-${key}`}
                                                            accept="image/*"
                                                            capture="environment"
                                                            // capture = "user"
                                                            onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                if (file) {
                                                                    handleImageChange(key, file);
                                                                }
                                                                // Reset file input so same file can be re-uploaded
                                                                e.target.value = null;
                                                            }}
                                                            style={{ display: "none" }}
                                                        />


                                                    </div>

                                                    <label className="absolute bottom-1 left-0 right-0 text-center text-xs font-semibold text-white bg-black bg-opacity-50 rounded-md mx-2 py-0.5">
                                                        {requiredImageKeys.includes(key) ? (
                                                            <>
                                                                {key.charAt(0).toUpperCase() + key.slice(1)}{' '}
                                                                <span className="contents text-red-800"></span>
                                                            </>
                                                        ) : (
                                                            key.charAt(0).toUpperCase() + key.slice(1)
                                                        )}

                                                    </label>


                                                </div>
                                            );
                                        })}
                                    </div>

                                    {Object.keys(images).length >= 6 && (
                                        <div className="flex justify-end  mb-4 px-2 py-1">

                                            <button
                                                type="button"
                                                onClick={handleAddImageField}
                                                className="px-4 py-2 bg-gray-700 text-white rounded-xl rounded-md hover:bg-gray-800"
                                            >
                                                ➕ Add
                                            </button>
                                        </div>)}



                                    <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10]">
                                        <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full  gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                            <button
                                                onClick={() => { localStorage.setItem('currentStep', '01'); setCurrentStep('01') }}


                                                className="flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full
                                                 bg-[#EE3840] hover:bg-[#d32f2f]"
                                        >
                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px] rotate-180" />
                                            Back
                                        </button>

                                        <button
                                            hidden
                                            onClick={() => { localStorage.setItem('currentStep', '03'); setCurrentStep('03') }}
                                            className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full ${Object.keys(images).length !== 4
                                                ? "bg-[#a7dbf5] cursor-not-allowed"
                                                : "bg-[#21A6E9] hover:bg-[#1e94d6]"
                                                }`}
                                        >
                                            Continue
                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                                        </button>

                                            <button
                                                disabled={!isContinueEnabled}
                                                onClick={() => {
                                                    localStorage.setItem('currentStep', '03');
                                                    setCurrentStep('03');
                                                }}
                                                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
    ${isContinueEnabled
                                                    ? 'bg-[#21A6E9] hover:bg-[#1e94d6]'
                                                    : 'bg-[#a7dbf5] cursor-not-allowed'
                                                }`}
                                        >
                                            Continue
                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                                        </button>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {currentStep === "03" && (
                        <div className="flex md:flex-row flex-col justify-center gap-[30px]">
                            <div className="bg-[linear-gradient(175deg, #ffffff, transparent)] md:bg-[#FFFFFF] max-w-[694px] w-full  rounded-[30px] md:py-[50px] py-[30px] md:px-[40px] px-[20px]">

                                <div className='  md:bg-[#ffffff] md:w-full rounded-[2rem]  max-w-[1148px] mx-auto p-[1rem] pb-[0.5rem] pt-[1rem] '>

                                    <div className="font-satoshi flex flex-col items-start mt-6 mb-[0.5rem]">
                                        <div className="flex items-start gap-3 md:-mt-[70px]">

                                            <div className="flex flex-col justify-center mt-[10]" style={{ marginTop: "5px" }}>
                                                <h2 className="text-[1rem] font-semibold">CHOOSE SUPPORT VEHICLE</h2>
                                                <p className="text-xs text-gray-500">Please choose the service you need.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 gap-[1rem]">






                                    <div className="w-full mb-[3rem] col-span-2  rounded-[30px] md:p-[2px] p-[20px]">
                                        <div className="grid grid-cols-1  gap-[24px]">
                                            {(selectedVehicleData.length === 0 || selectedVehicleData.includes('crane')) && (
                                                <div>
                                                    <div
                                                        className={`flex flex-col items-center overflow-hidden rounded-2xl shadow-[20px_20px_20px_rgba(0,0,0,0.3)]  bg-[#f6f2f2] cursor-pointer transition-shadow duration-300 hover:shadow-2xl ${selectedCrane ? 'ring-2 ring-yellow-400' : ''}`}
                                                        onClick={() => {
                                                            const newValue = !selectedCrane;
                                                            if (newValue) {
                                                                localStorage.setItem('vehicleType', 'crane');
                                                                localStorage.setItem('currentService', 'crane');
                                                                localStorage.removeItem('flatbedOption');
                                                                setSelectedNonFlatbed(false);
                                                                setSelectedFlatbed(false);

                                                                setVehicleType('crane');
                                                            } else {
                                                                localStorage.removeItem('vehicleType');
                                                                localStorage.removeItem('currentService')
                                                                localStorage.removeItem('flatbedOption');
                                                                setSelectedNonFlatbed(false);
                                                                setSelectedFlatbed(false);
                                                                setVehicleType(null);
                                                            }

                                                        setSelectedCrane(newValue);
                                                        setSelectedRecoveryVan(false);
                                                        setSelectedBoth(false);
                                                    }}
                                                >
                                                    <div className="w-full aspect-[8/3] overflow-hidden">
                                                        <img
                                                            // src="https://cdn.leonardo.ai/users/ad8e5f61-d0b6-407e-b941-75e27c29b608/generations/20aa7104-dd5b-4c89-8013-c72c34624f43/segments/4:4:1/Flux_Dev_Create_a_realistic_detailed_image_of_a_yellow_hydra_c_3.jpg"
                                                            src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumCrane.jpg'
                                                            className="w-full h-[75%] object-contain transition-transform duration-300 hover:scale-105"
                                                            alt="Hydra Crane"
                                                        />
                                                    </div>
                                                    <h6 className="text-center font-satoshi text-sm md:text-base font-semibold mb-3">Hydra Crane</h6>
                                                </div>
                                            </div>
                                        )}

                                            {/* Non-flat-bed Recovery Van */}
                                            {(selectedVehicleData.length === 0 || selectedVehicleData.includes('recoveryVan')) && (
                                                <div>
                                                    <div
                                                        className={`flex flex-col items-center overflow-hidden rounded-2xl shadow-[20px_20px_20px_rgba(0,0,0,0.3)]  cursor-pointer  bg-white transition-shadow duration-300 hover:shadow-2xl ${selectedNonFlatbed ? 'ring-2 ring-yellow-400' : ''}`}
                                                        onClick={() => {
                                                            const newValue = !selectedNonFlatbed;

                                                            setSelectedNonFlatbed(newValue);
                                                            setSelectedFlatbed(false);
                                                            setSelectedCrane(false);
                                                            setSelectedBoth(false);

                                                        if (newValue) {
                                                            localStorage.setItem('vehicleType', 'recoveryVan');
                                                            localStorage.setItem('currentService', 'recoveryVan');
                                                            localStorage.setItem('flatbedOption', 'Non-flat-bed');
                                                            setVehicleType('recoveryVan');
                                                            setFlatOption('Non-flat-bed');
                                                        } else {
                                                            localStorage.removeItem('vehicleType');
                                                            localStorage.removeItem('currentService');
                                                            localStorage.removeItem('flatbedOption');
                                                            setVehicleType(null);
                                                            setFlatOption(null);
                                                            setFullAddress(null);
                                                        }
                                                    }}
                                                >
                                                    <div className="w-full aspect-[8/3] overflow-hidden">
                                                        <img
                                                            src={mediumRecoveryVanImage}
                                                            className="w-full h-full object-contain transition-transform duration-300 hover:scale-105"
                                                            alt="Recovery Van"
                                                        />
                                                    </div>
                                                    <h6 className="text-center font-satoshi text-sm md:text-base font-semibold mb-3">Recovery Van (Non-flat-bed)</h6>
                                                </div>
                                            </div>
                                        )}

                                            {/* Flat-bed Recovery Van */}
                                            {(selectedVehicleData.length === 0 || selectedVehicleData.includes('recoveryVan')) && (
                                                <div>
                                                    <div
                                                        className={`flex flex-col items-center overflow-hidden rounded-2xl shadow-[20px_20px_20px_rgba(0,0,0,0.3)]  cursor-pointer  bg-white transition-shadow duration-300 hover:shadow-2xl ${selectedFlatbed ? 'ring-2 ring-yellow-400' : ''}`}
                                                        onClick={() => {
                                                            const newValue = !selectedFlatbed;

                                                            setSelectedFlatbed(newValue);
                                                            setSelectedNonFlatbed(false);
                                                            setSelectedCrane(false);
                                                            setSelectedBoth(false);

                                                        if (newValue) {
                                                            localStorage.setItem('vehicleType', 'recoveryVan');
                                                            localStorage.setItem('currentService', 'recoveryVan');
                                                            localStorage.setItem('flatbedOption', 'Flat-bed');
                                                            setVehicleType('recoveryVan');
                                                            setFlatOption('Flat-bed');
                                                        } else {
                                                            localStorage.removeItem('vehicleType');
                                                            localStorage.removeItem('currentService');
                                                            localStorage.removeItem('flatbedOption');
                                                            setVehicleType(null);
                                                            setFlatOption(null);
                                                            setFullAddress(null);
                                                        }
                                                    }}
                                                >
                                                    <div className="w-full aspect-[8/3] overflow-hidden">
                                                        <img
                                                            src={mediumFlatbedImage}
                                                            className="w-full h-full object-contain transition-transform duration-300 hover:scale-105"
                                                            alt="Flat-bed Recovery Van"
                                                        />
                                                    </div>
                                                    <h6 className="text-center font-satoshi text-sm md:text-base font-semibold mb-3">Recovery Van (Flat-bed)</h6>
                                                </div>
                                            </div>
                                        )}


                                            {(selectedVehicleData.length === 0 || (selectedVehicleData.includes('crane') && selectedVehicleData.includes('recoveryVan'))) && (
                                                <div>
                                                    <div hidden
                                                        className={`flex flex-col items-center overflow-hidden rounded-2xl shadow-[20px_20px_20px_rgba(0,0,0,0.3)] cursor-pointer transition-shadow duration-300  bg-[#FFFFFF] hover:shadow-2xl ${selectedBoth ? 'ring-2 ring-yellow-400' : ''}`}
                                                        onClick={() => {
                                                            const newValue = !selectedBoth;
                                                            if (newValue) {
                                                                localStorage.setItem('vehicleType', 'crane,recoveryVan');
                                                                setVehicleType('crane,recoveryVan');
                                                            } else {
                                                                localStorage.removeItem('vehicleType');
                                                                setVehicleType(null);
                                                            }

                                                            setSelectedBoth(newValue);
                                                            setSelectedCrane(false);
                                                            setSelectedRecoveryVan(false);
                                                        }}

                                                    >
                                                        <div className="w-full aspect-[8/3] flex overflow-hidden">
                                                            <img
                                                                src="https://cdn.leonardo.ai/users/ad8e5f61-d0b6-407e-b941-75e27c29b608/generations/20aa7104-dd5b-4c89-8013-c72c34624f43/segments/4:4:1/Flux_Dev_Create_a_realistic_detailed_image_of_a_yellow_hydra_c_3.jpg"
                                                                className="w-1/2 h-full object-contain object-bottom"
                                                                alt="Hydra Crane"
                                                            />
                                                            <img
                                                                src="https://cdn.leonardo.ai/users/ad8e5f61-d0b6-407e-b941-75e27c29b608/generations/5199123c-69de-42db-b3ed-714423a253c1/segments/4:4:1/Flux_Dev_Create_a_realistic_detailed_image_of_a_yellow_recover_3.jpg"
                                                                className="w-1/2 h-full object-contain object-bottom"
                                                                alt="Recovery Truck"
                                                            />
                                                        </div>
                                                        <h6 className="text-center font-satoshi text-sm md:text-base font-semibold my-3">
                                                            Recovery + Hydra Crane
                                                        </h6>
                                                    </div>
                                                </div>
                                            )}


                                        </div>
                                    </div>




                                    <ModalForQuantity
                                        isOpen={isModalOpenQuantity}
                                        onClose={() => setIsModalOpenQuantity(false)}
                                        quantity={quantity}
                                        setQuantity={setQuantity}
                                        getVendorsWithLocation={getVendorsWithLocation}
                                        setCurrentStep={setCurrentStep}
                                    />

                                    <ModalForFlatBed
                                        isOpen={isModalFlatBed}
                                        onClose={() => setIsModalFlatBed(false)}
                                        setFlatOption={setFlatOption}
                                        flatOption={flatOption}
                                        setCurrentStep={setCurrentStep}
                                        getVendorsWithLocationForFlatBed={getVendorsWithLocationForFlatBed}
                                    />

                                    <ModalForQuantityAndFlatBed
                                        isOpen={isModalQuantityFlatBed}
                                        onClose={() => setIsModalQuantityFlatBed(false)}
                                        quantity={quantity}
                                        setQuantity={setQuantity}
                                        getVendorsWithLocation={getVendorsWithLocation}
                                        setFlatOption={setFlatOption}
                                        getVendorsWithLocationForFlatBed={getVendorsWithLocationForFlatBed}
                                        setCurrentStep={setCurrentStep}

                                    />


                                </div>
                                <div className="flex font-satoshi justify-center fixed bottom-0 left-0 right-0 z-[9999] ">
                                    <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                        <button
                                            onClick={() => { localStorage.setItem('currentStep', '02'); setCurrentStep('02') }}

                                            className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"

                                    >
                                        <img src={rightArrow} alt="Continue" className="h-[24px] w-[24px] rotate-180" />
                                        Back
                                    </button>
                                    <button
                                        disabled={vehicleType == null}
                                        onClick={() => {
                                            if (vehicleType !== null && vehicleType == 'crane') {
                                                setIsModalOpenQuantity(true)
                                                // getVendorsWithLocation(); setCurrentStep('04')
                                            }
                                            else if (vehicleType !== null && vehicleType == 'recoveryVan' && flatOption != null) {
                                                // setIsModalFlatBed(true)
                                                console.log('hitting it')
                                                getVendorsWithLocationForFlatBed(); setCurrentStep('04')
                                            }
                                            else if (vehicleType !== null && vehicleType == 'crane,recoveryVan') {
                                                setIsModalQuantityFlatBed(true)
                                            }
                                            else if (vehicleType !== null) {
                                                getVendorsWithLocation();
                                                setCurrentStep('04');
                                            }
                                        }}
                                        className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full ${vehicleType !== null
                                            ? "bg-[#21A6E9] hover:bg-[#1e94d6]"
                                            : "bg-[#a7dbf5] cursor-not-allowed"
                                            }`}
                                    >
                                        Continue
                                        <img src={rightArrow} alt="Back" className="h-[24px] w-[24px]" />
                                    </button>
                                </div>
                            </div>



                            </div>
                        </div>
                    )}


                    {currentStep === '04' && (
                        <div className='h-[100vh] bg-white pt-[3rem]'>
                            <TestMapLoader
                                setCurrentStep={setLoaderStage}
                                incomingAccidentCode={incomingAccidentCode}
                                isLoading={isLoading}
                                setChooseFromSelectedServiceFinal={setChooseFromSelectedServiceFinal} // setChooseFromSelectedServiceFinalForCrane
                                chooseFromSelectedServiceFinal={chooseFromSelectedServiceFinal} // chooseFromSelectedServiceFinalForCrane
                                pickupLocation={pickupLocation}
                                setPickupLocation={setPickupLocation}
                                dropLocation={dropLocation}
                                setDropLocation={setDropLocation}
                                stats={stats}
                                setVehicleType={setVehicleType} // setVehicleTypeCrane
                                vehicleType={vehicleType} // vehicleTypeCrane
                                handleSubmit={handleSubmit}
                                isModalWaitingProp={isModalWaiting}  // isModalWaitingCrane
                                setIsModalWaiting={setIsModalWaiting} // setIsModalWaitingCrane
                                vendorData={vendorData}
                                setAccidentDataObject={setAccidentDataObject}
                                quantity={quantity}
                                chooseFromSelectedSubServiceFinal={localStorage.getItem('flatbedOption')}
                                unloadWeight={unloadWeight}
                            />

                        </div>
                    )}

                    {currentStep === '05' && (
                        <div >
                            {/* {successDone === false && (
                            <div className="h-screen bg-gray-100">
                                <div className='relative w-full h-[100%] overflow-hidden'>
                                    <img
                                        src="https://www.kaashivinfotech.com/tutorial/wp-content/uploads/2020/06/Google-Map-US_10.jpg"
                                        alt="Loading"
                                        className="absolute inset-0 w-full h-full object-cover"
                                    />
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" width="150" height="150">
                                            <g fill="none" stroke="#1770AD" strokeWidth="2">
                                                <circle cx="22" cy="22" r="1">
                                                    <animate attributeName="r" values="1; 20" dur="1.8s" repeatCount="indefinite" />
                                                    <animate attributeName="stroke-opacity" values="1; 0" dur="1.8s" repeatCount="indefinite" />
                                                </circle>
                                                <circle cx="22" cy="22" r="1">
                                                    <animate attributeName="r" values="1; 20" dur="1.8s" begin="0.9s" repeatCount="indefinite" />
                                                    <animate attributeName="stroke-opacity" values="1; 0" dur="1.8s" begin="0.9s" repeatCount="indefinite" />
                                                </circle>
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="absolute inset-0 bg-black/40" />
                                </div>
                            </div>

                        )}
                        {successDone === true && ( */}
                            <div className="h-screen bg-gray-100">
                                <ContactingServiceCard
                                    isLoading={true}
                                    setIsLoading={setIsLoading}
                                    getVendorsWithLocation={getVendorsWithLocation}
                                    getVendorsWithLocationForFlatBed={getVendorsWithLocationForFlatBed}
                                    setChooseFromSelectedServiceFinal={setChooseFromSelectedServiceFinal}
                                    setCurrentStep={setCurrentStep}
                                    currentService={vehicleType}
                                    chooseFromSelectedServiceFinal={chooseFromSelectedServiceFinal}
                                    incomingAccidentVehicleCode={accidentVehicleCode}
                                    trackRepeatedRequests={trackRepeatedRequests}
                                    minEstimatedDuration={minEstimatedDuration}
                                    maxEstimatedDuration={maxEstimatedDuration}
                                    // estimatedUrl={estimatedUrl}
                                    minEstimatedAmount={minEstimatedAmount}
                                    maxEstimatedAmount={maxEstimatedAmount}
                                    stats={stats}
                                    handleSubmit={handleSubmit}

                                />
                            </div>
                            {/* )} */}
                        </div>


                    )}

                </div >
            </div>

        </>
    )
}

export default AddVehicles;


function ModalForQuantity({ isOpen, onClose, quantity, setQuantity, getVendorsWithLocation, setCurrentStep }) {
    const [inputValue, setInputValue] = useState('');
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">

            <div className="bg-white py-[42px] px-[50px] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                {/* <h6 className="m-0 font-[500] text-[28px] font-satoshi text-center text-[#000000]"></h6> */}

                {/* <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" /> */}

                <div class="form-check ">

                    <label className="form-check-label" htmlFor="flexCheckDefault">

                    </label>
                </div>

                <h6 className=" font-[500] text-[20px] font-satoshi  text-[#000000]">Enter loaded weight of the Material (in Tons)
                </h6>
                <input
                    type="number"
                    min="0"
                    placeholder="Enter loaded weight"
                    className="mt-5 text-lg w-full text-center focus:outline-none focus:ring-2 focus:ring-[#21A6E9] rounded-[20px] border border-gray-300"
                    value={inputValue}
                    onChange={(e) => {
                        let val = e.target.value;

                        // Remove non-numeric characters and leading zeros
                        val = val.replace(/\D/g, '').replace(/^0+/, '');

                        setInputValue(val);

                        if (val) {
                            setQuantity(val + '000'); // Store 45000
                        } else {
                            setQuantity('');
                        }
                    }}
                    autoFocus
                    maxLength={5} // Only allow 5 visible digits
                />


                <div className={`grid ${quantity ? 'grid-cols-1' : 'grid-cols-2'}  md: pt-[40px] items-center gap-[18px]`}>
                    {!quantity && (
                        <div
                            onClick={() => {
                                getVendorsWithLocation(); setCurrentStep('04')
                                onClose();
                            }}

                            className={`bg-[#EE3840] flex py-[5px] rounded-full pr-[0.5rem] pl-[1rem] w-full justify-between items-center cursor-pointer whitespace-nowrap`}>
                            <button className="font-satoshi font-[400] text-[13px] leading-[33.6px] pr-[0.3rem] text-[#FFFFFF]">Empty</button>
                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[1rem] w-[1rem]' alt="" />
                        </div>
                    )}

                    <div
                        onClick={() => {
                            if (quantity) {
                                getVendorsWithLocation();
                                setCurrentStep('04');
                                onClose();
                            }
                        }}
                        className={`flex py-[5px] rounded-full pr-[0.5rem] pl-[1rem] w-full cursor-pointer justify-between items-center 
              ${quantity ? 'bg-[#21A6E9] hover:bg-[#1e94d6]' : 'bg-gray-400 cursor-not-allowed'}`}>
                        <button
                            className="font-satoshi font-[400] text-[13px] leading-[33.6px] text-[#FFFFFF]"
                            disabled={!quantity}
                        >
                            Continue
                        </button>
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className="h-[1rem] w-[1rem]" alt="" />
                    </div>



                </div>

            </div>
        </div>
    );
};


function ModalLast({ isOpen, onClose, }) {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
            <div className="bg-white py-[42px] px-[50px] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                <button
                    type="button"
                    onClick={onClose}
                    className="absolute top-1 right-2 bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-700"
                >
                    ❌
                </button>
                <div className="flex gap-2 items-center justify-center">
                    <ClipLoader size={20} color="#ffffff" />
                    <span className='flex gap-2 items-center justify-center"'>Searching For Vendors...</span>
                </div>
                <h6 className="m-0 font-[500] text-[18px] font-satoshi text-center text-[#000000]">Connecting to Vendors wait for 3 minutes </h6>
                <div
                    onClick={onClose}
                    className="bg-[#EE3840] flex py-[5px] mt-5 rounded-full pr-[6px] pl-[26px] w-full justify-between items-center cursor-pointer">
                    <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] pr-[36px] text-[#FFFFFF]">Waiting...</button>
                    {/* <img src="/assets/navbar/right-arrow.svg" alt="" /> */}
                </div>
            </div>
        </div>
    );
};

function ModalForFlatBed({ isOpen, onClose, setFlatOption, setCurrentStep, getVendorsWithLocationForFlatBed }) {
    const [selectedFilter, setSelectedFilter] = useState(null);

    const modalRef = useRef(null);

    useEffect(() => {
        // return
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();

            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen,]);

    useEffect(() => {

        if (selectedFilter === 'a') {
            setFlatOption('Flat-bed');
        }
        if (selectedFilter === 'b') {
            setFlatOption('Non-flat-bed');
        }


    }, [selectedFilter])

    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">

            <div ref={modalRef} className="bg-white py-[42px] px-[1rem] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">

                <h6 className=" font-[500] text-[20px] font-satoshi text-center text-[#000000]">Select Recovery Van Type
                </h6>


                <div className="flex justify-center my-4 gap-4">
                    <div
                        onClick={() => {
                            setSelectedFilter('a');
                            localStorage.setItem('flatbedOption', 'Flat-bed');
                            getVendorsWithLocationForFlatBed();
                            setCurrentStep('04');
                            onClose();
                        }}
                        className={`px-4 py-2 rounded-lg border text-sm font-semibold cursor-pointer ${selectedFilter === 'a'
                            ? 'bg-white text-gray-700 border-gray-300'
                            : 'bg-blue-600 text-white border-blue-600'
                            }`}
                    >
                        Flatbed
                    </div>

                    <div
                        onClick={() => {
                            setSelectedFilter('b');
                            localStorage.setItem('flatbedOption', 'Non-flat-bed');
                            getVendorsWithLocationForFlatBed();
                            setCurrentStep('04');
                            onClose();
                        }}
                        className={`px-4 py-2 rounded-lg border text-sm font-semibold cursor-pointer ${selectedFilter === 'b'
                            ? 'bg-white text-gray-700 border-gray-300'
                            : 'bg-red-300 text-gray-800 border-red-600'
                            }`}
                    >
                        Non-flatbed
                    </div>
                </div>


            </div>
        </div>
    );
};


function ModalForQuantityAndFlatBed({
    isOpen,
    onClose,
    quantity,
    setQuantity,
    getVendorsWithLocation,
    setFlatOption,
    getVendorsWithLocationForFlatBed,
    setCurrentStep,
}) {
    const [selectedFilter, setSelectedFilter] = useState(null);
    const modalRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    useEffect(() => {
        if (selectedFilter === 'a') {
            setFlatOption('Flat-bed');
            localStorage.setItem('flatbedOption', 'Flat-bed');
            getVendorsWithLocationForFlatBed();
        } else if (selectedFilter === 'b') {
            setFlatOption('Non-flat-bed');
            localStorage.setItem('flatbedOption', 'Non-flat-bed');
            getVendorsWithLocationForFlatBed();
        }
    }, [selectedFilter]);

    const handleContinue = () => {
        if (quantity && selectedFilter) {
            getVendorsWithLocation();
            setCurrentStep('04');
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
            <div ref={modalRef} className="bg-white py-[42px] px-[1rem] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                <h6 className="font-[500] text-[20px] font-satoshi text-center text-[#000000]">
                    Enter loaded weight of the Material (in Tons)
                </h6>

                <input
                    type="number"
                    min="0"
                    placeholder="Enter loaded weight"
                    className="mt-5 text-lg w-full text-center focus:outline-none focus:ring-2 focus:ring-[#21A6E9] rounded-[20px] border border-gray-300"
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                    autoFocus
                    maxLength={5}
                />

                <h6 className="mt-6 font-[500] text-[20px] font-satoshi text-center text-[#000000]">
                    Select Recovery Van Type
                </h6>

                <div className="flex justify-center my-4 gap-4">
                    <div
                        onClick={() => setSelectedFilter('a')}
                        className={`px-4 py-2 rounded-lg border text-sm font-semibold cursor-pointer ${selectedFilter === 'a'
                            ? 'bg-white text-gray-700 border-gray-300'
                            : 'bg-blue-600 text-white border-blue-600'
                            }`}
                    >
                        Flatbed
                    </div>

                    <div
                        onClick={() => setSelectedFilter('b')}
                        className={`px-4 py-2 rounded-lg border text-sm font-semibold cursor-pointer ${selectedFilter === 'b'
                            ? 'bg-white text-gray-700 border-gray-300'
                            : 'bg-red-300 text-gray-800 border-red-600'
                            }`}
                    >
                        Non-flatbed
                    </div>
                </div>

                <div className="grid pt-[20px] items-center gap-[18px]">
                    <div
                        onClick={handleContinue}
                        className={`flex py-[5px] rounded-full pr-[0.5rem] pl-[1rem] w-full cursor-pointer justify-between items-center 
              ${quantity && selectedFilter ? 'bg-[#21A6E9] hover:bg-[#1e94d6]' : 'bg-gray-400 cursor-not-allowed'}`}
                    >
                        <button
                            className="font-satoshi font-[400] text-[13px] leading-[33.6px] text-[#FFFFFF]"
                            disabled={!quantity || !selectedFilter}
                        >
                            Continue
                        </button>
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className="h-[1rem] w-[1rem]" alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
}








